import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const SingleCellPage = () => {
  return <TechnicalServicePage serviceKey="singleCell" />
}

export default SingleCellPage
